/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is the result blank?`)
};

const es_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué el resultado está en blanco?`)
};

const de_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist das Ergebnis leer?`)
};

const nl_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is het resultaat leeg?`)
};

const fr_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi le résultat est-il vide ?`)
};

const it_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il risultato è vuoto?`)
};

const pt_br2_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que o resultado está em branco?`)
};

const pt_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que o resultado está em branco?`)
};

const ja_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果が空欄になるのはなぜですか？`)
};

const zh_soldil_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么结果是空白的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_faq_q4", locale)
	if (locale === "en") return en_soldil_faq_q4(inputs)
	if (locale === "es") return es_soldil_faq_q4(inputs)
	if (locale === "de") return de_soldil_faq_q4(inputs)
	if (locale === "nl") return nl_soldil_faq_q4(inputs)
	if (locale === "fr") return fr_soldil_faq_q4(inputs)
	if (locale === "it") return it_soldil_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_faq_q4(inputs)
	if (locale === "pt") return pt_soldil_faq_q4(inputs)
	if (locale === "ja") return ja_soldil_faq_q4(inputs)
	return zh_soldil_faq_q4(inputs)
};